import { BetSlipMode } from "../types/enums";
import { StateActionTypes } from "../types/enums";
import { dispatchCustomEvent } from "../shared/utils/bet-slip";

export const configHandlers: ReducerHandlers = {
  [StateActionTypes.UPDATE_CONFIG]: (state, action) => {
    const updatedConfig = { ...state.config, ...action.payload };
    return {
      ...state,
      config: updatedConfig,
      betSlipState: { ...state.betSlipState },
    };
  },

  [StateActionTypes.TOGGLE_ACCEPT_ODDS_CHANGES]: (state, action) => ({
    ...state,
    betSlipState: {
      ...state.betSlipState,
      acceptOddsChanges: action.payload,
    },
  }),

  [StateActionTypes.SET_SOURCE]: (state, action) => ({
    ...state,
    betSlipState: {
      ...state.betSlipState,
      source: action.payload.source,
      sourceRef: action.payload.sourceRef,
    },
  }),

  [StateActionTypes.SET_MODE]: (state, action) => {
    if (action.payload === BetSlipMode.Single) {
      dispatchCustomEvent(StateActionTypes.CLEAR_ALL_BB_BETS);
    }
    return {
      ...state,
      betSlipState: {
        ...state.betSlipState,
        mode: action.payload,
      },
    };
  },
};
